export default {
  ACTIVE: {
    Title: 'Active',
    Color: '#FFF7F4',
    ColorBorder: '#EBBDAD',
    ColorText: '#DA7955',
    primary: false,
    secondary: false,
  },
  REVIEW: {
    Title: 'Pending Review',
    Color: '#EEF4FF',
    ColorBorder: '#C6D7FF',
    ColorText: '#5876C6',
    primary: false,
    secondary: false,
  },
  INACTIVE: {
    Title: 'Inactive',
    Color: '#F3F1EE',
    ColorBorder: '#D8D3CC',
    ColorText: '#6B6760',
    primary: false,
    secondary: false,
  },
};
